/* eslint-disable @typescript-eslint/no-unused-vars */
function noop(...args: any[]): any {
    return;
}

export default noop;
